export const OPERATION_MODELS = [
  'FULL_SERVICE',
  'PICK_AND_COLLECT',
  'PICK_AND_DELIVERY',
  'PICK_AND_DELIVERY_WITH_STORAGE',
  'PICK_AND_COLLECT_NO_TRANSFER',
  'PICK_AND_DELIVERY_WITH_STORAGE_NO_TRANSFER',
  'ZONE_PICKING_AND_DELIVERY_WITH_STORAGE',
  'ZONE_PICKING_AND_COLLECT'
]

export const PARTIAL_STATUSES_WITH_COLORS = {
  CREATED: '#D1D4D9',
  GOING_TO_ORIGIN: '#B37FEB',
  PICKING: '#722ED1',
  PICKING_WITH_PACKING: '#FAAD14',
  PICKING_WITH_UNASSIGNED_ZONE: '#FF85C0',
  PARKED: '#EB2F96',
  AUDITING: '#FF7A45',
  CHECKOUT: '#D46B08',
  TRANSFERRING: '#40A9FF',
  STORING: '#096DD9',
  STORED: '#36CFC9',
  READY_FOR_PICKUP: '#08979C',
  GOING_TO_DESTINATION: '#A0D911',
  IN_ROUTE: '#52C41A',
  DELIVERED: '#389E0D',
  FINISHED: '#135200',
  CANCELLED: '#CF1322'
}

export const PAYMENT_METHODS = {
  CASH: 'CASH',
  PAYMENT_TERMINAL: 'PAYMENT_TERMINAL',
  LOYALTY_CARD: 'LOYALTY_CARD',
  PREPAID: 'PREPAID',
  PAYMENT_LINK: 'PAYMENT_LINK',
  TRANSFER: 'TRANSFER'
}

export const TASK_ICONS = {
  FULL_SERVICE: { icon: 'FullService', text: 'tasks-status.FULL_SERVICE' },
  DELIVERY: { icon: 'Truck', text: 'driver' },
  PICKING: { icon: 'Shopper', text: 'picker' },
  STORAGE: { icon: 'Package', text: 'tasks-status.STORAGE' },
  CONSOLIDATION: { icon: 'Consolidation', text: 'tasks-status.CONSOLIDATION' },
  PICKING_WITH_PACKING: { icon: 'PickingWithPacking', text: 'tasks-status.PICKING_WITH_PACKING' },
  ZONE_PICKING: { icon: 'ZonePicking', text: 'tasks-status.ZONE_PICKING' },
  DEPARTMENTS: { icon: 'Departments', text: 'tasks-status.ZONE_PICKING' },
  PICKING_WITH_STORAGE: { icon: 'Shopper', text: 'tasks-status.PICKING_WITH_STORAGE' },
  DELIVERY_WITH_STORAGE: { icon: 'Truck', text: 'tasks-status.DELIVERY_WITH_STORAGE' },
  PICKING_AND_STORAGE: { icon: 'Package', text: 'tasks-status.PICKING_AND_STORAGE' },
  PICKING_MULTI_STOP: { icon: 'Path', text: 'tasks-status.PICKING_MULTI_STOP' },
  PICKING_VERIFICATION: { icon: 'Eye', text: 'tasks-status.PICKING_VERIFICATION' }
}

export const FEATURE_FLAGS_PARAMS = {
  HAS_OPS_METRICS: 'hasOpsMetrics'
}

export const REASON_PARAMS = {
  CANCELLATION: 'CANCELLATION',
  RESCHEDULE: 'RESCHEDULE',
  REPLENISH: 'REPLENISH',
  REJECT: 'REJECT'
}

export const ACTIVITY_LOG_EVENT_TYPES = {
  POST_USERS: 'create a user',
  PUT_USERS: 'update a user',
  DELETE_USERS: 'delete a user',
  POST_RESOURCES: 'create a resource',
  PUT_USERS_STATUS: 'update user (status changed)',
  PUT_RESOURCES: 'update a resource',
  POST_STORES: 'create a store',
  PUT_STORE: 'update a store',
  POST_FLEETS: 'create a fleet',
  PUT_FLEET: 'update a fleet',
  POST_QUOTAS: 'create fleet quotas',
  PUT_FLEETPERMISSIONS: 'update a resource fleet permissions',
  PUT_DELETE_BY_RESOURCE: 'remove quotas by resource',
  POST_CREATE_BY_RESOURCE: 'create quotas by resource',
  PUT_UPDATE_QUOTAS_BY_RESOURCE: 'update quotas by resource',
  POST_USERS_MASSIVE_CREATION: 'massive user creation',
  DELETE_RESOURCES: 'delete resource',
  PUT_UPDATE_LOGISTICS_PARAMETERS: 'update logistics parameters',
  POST_RESTORE_RESOURCES: 'restore resource',
  PUT_WANTS_TO_RECEIVE_TASKS: 'update resource availability'
}
